<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fEY3df/tc-custom/9781488067433.jpg?1725275754058" alt="This image is the cover for the book Isolated Threat, The Badlands Cops Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Isolated Threat, The Badlands Cops Novels
      </h1>
      <p class="bookDescription body article font2">
        <b>A local police officer and a beautiful tribal cop team up to keep a baby from his gang leader father in this romantic suspense.</b><br/><br/>They’ll stop at nothing to protect a child.<br/><br/>Ever since he escaped his father’s biker gang, sheriff’s deputy Brady Wyatt has never looked back. Then Cecilia Mills asks Brady to help her hide a child from the delinquent crew. But when threats impact the safety of the makeshift family, will they find a way to protect themselves . . . or will the Sons of the Badlands take the child back into its dangerous grip?<br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nicole Helm
      </h2>
      
      <p class="authorDescription body article">Nicole Helm writes down-to-earth contemporary romance and fast-paced romantic suspense.&#160;She lives with her husband and two sons in Missouri.&#160;Visit her website: www.nicolehelm.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?46f0fe86